// Import dependencies
import { html } from 'lit';

// Translatable strings
const strings = UncannyAutomator._core.i18n.core.directoryLoop;

/**
 * Retrieves directory fields data and sentence based on the given type.
 *
 * @param {String} type - The type of iterable expression (e.g., 'token').
 * @return {Object} An object containing directory fields data and sentence.
 */
const getLoop = ( type ) => {
	const directoryMap = {
		token: {
			fields: [
				{
					option_code: 'TOKEN',
					type: 'text',
					label: strings.token.fields.token.label,
					required: true,
					supports_tokens: true,
					only_loopable_tokens: true,
					show_label_in_sentence: false,
					clear_when_adding_token: true
				}
			],
			sentence: strings.token.sentence,
			dialog_helper: html`
				${ strings.token.dialogHelper.loopTokens } <a href="${ _uo.utility.addParametersUTM( 'https://automatorplugin.com/knowledge-base/token-loops/', { medium: 'token_loop_dialog', content: 'learn_more' } ) }" target="_blank">${ strings.token.dialogHelper.loopTokensLearnMore } <uo-icon id="external-link"></uo-icon></a>
			`
		}
	};

	return directoryMap[ type ] || {};
}

export default getLoop;
